// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.assessmentandplan.PatientTriggerOutcomeResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientTriggerOutcomeResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	actionTaken!: string | null;

	@GandalfConstantDecorator(constants.CarePlanItemCategory)
	@GandalfProperty({ designType: constants.CarePlanItemCategory })
	carePlanItemCategory!: constants.CarePlanItemCategory | null;

	@GandalfProperty({ designType: String })
	clinicalExceptionComments!: string | null;

	@GandalfProperty({ designType: String })
	clinicalExceptionSnomedCodeDescription!: string | null;

	@GandalfConstantDecorator(constants.PatientTriggerOutcomeConfirmation)
	@GandalfProperty({ designType: constants.PatientTriggerOutcomeConfirmation })
	confirmationStatus!: constants.PatientTriggerOutcomeConfirmation | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: String })
	feedback!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfConstantDecorator(constants.TriggerOutcomeType)
	@GandalfProperty({ designType: constants.TriggerOutcomeType })
	outcomeType!: constants.TriggerOutcomeType | null;

	@GandalfProperty({ designType: Number })
	practiceFileId!: number | null;

	@GandalfProperty({ designType: String })
	queryTriggerQueryName!: string | null;

	@GandalfProperty({ designType: Number })
	snomedCodeId!: number | null;

	@GandalfProperty({ designType: String })
	webSite!: string | null;

}
